import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const AjustarFeriasCivilService = {
  async getById(id) {
    const response = await BaseService.fetchResponseFromAPIGet(`civil/ajusteferias/justificarecusa/${id}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao consultar as informações deste item", "error");
    }
    return response.content;
  },

  async ajustarFerias(postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `civil/ajusteferias`,
      postData,
    );
    if (response.error) {
      SnackBarModule(response.message.error, "error");
      return false;
    }
    SnackBarModule("Ajuste de férias enviado com sucesso.", "success");
    return true;
  },
}